var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0966 1.66072L14.3521 5.40527C12.8338 4.86491 11.1662 4.86491 9.64788 5.40526L5.90335 1.66073C9.65254 -0.553573 14.3474 -0.553576 18.0966 1.66072Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3393 18.0966C24.5536 14.3475 24.5536 9.65255 22.3393 5.90336L18.5947 9.64791C19.1351 11.1662 19.1351 12.8338 18.5947 14.3521L22.3393 18.0966Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3521 18.5947L18.0966 22.3393C14.3474 24.5536 9.65254 24.5536 5.90336 22.3393L9.64789 18.5947C11.1662 19.1351 12.8338 19.1351 14.3521 18.5947Z",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40524 9.6479L1.66072 5.90337C-0.553573 9.65256 -0.553572 14.3474 1.66072 18.0966L5.40524 14.3521C4.86489 12.8338 4.86489 11.1662 5.40524 9.6479Z",
    fill: "#474747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2426 7.75737C17.0237 8.53842 18.29 8.53842 19.071 7.75737L21.1924 5.63605C21.9734 4.855 21.9734 3.58867 21.1924 2.80762C20.4113 2.02657 19.145 2.02657 18.3639 2.80762L16.2426 4.92894C15.4616 5.70999 15.4616 6.97632 16.2426 7.75737ZM18.364 7.05025C17.9734 7.44077 17.3403 7.44077 16.9498 7.05025C16.5592 6.65972 16.5592 6.02656 16.9498 5.63603L19.0711 3.51471C19.4616 3.12419 20.0948 3.12419 20.4853 3.51471C20.8758 3.90524 20.8758 4.5384 20.4853 4.92892L18.364 7.05025Z",
    fill: "#474747"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80759 5.63605C2.02654 4.855 2.02654 3.58867 2.80759 2.80762C3.58864 2.02657 4.85497 2.02657 5.63602 2.80762L7.75734 4.92894C8.53838 5.70999 8.53838 6.97632 7.75734 7.75737C6.97629 8.53842 5.70996 8.53842 4.92891 7.75737L2.80759 5.63605ZM3.51472 4.92894C3.1242 4.53841 3.1242 3.90525 3.51472 3.51472C3.90525 3.1242 4.53841 3.1242 4.92894 3.51472L7.05026 5.63604C7.44078 6.02657 7.44078 6.65973 7.05026 7.05026C6.65973 7.44078 6.02657 7.44078 5.63604 7.05026L3.51472 4.92894Z",
    fill: "#474747"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63601 21.1924C4.85497 21.9734 3.58864 21.9734 2.80759 21.1924C2.02654 20.4113 2.02654 19.145 2.80759 18.364L4.92891 16.2426C5.70996 15.4616 6.97629 15.4616 7.75734 16.2426C8.53838 17.0237 8.53838 18.29 7.75734 19.0711L5.63601 21.1924ZM3.51469 20.4853C3.90522 20.8758 4.53838 20.8758 4.92891 20.4853L7.05023 18.364C7.44075 17.9734 7.44075 17.3403 7.05023 16.9497C6.6597 16.5592 6.02654 16.5592 5.63602 16.9497L3.51469 19.0711C3.12417 19.4616 3.12417 20.0947 3.51469 20.4853Z",
    fill: "#474747"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2426 16.2426C15.4616 17.0237 15.4616 18.29 16.2426 19.0711L18.3639 21.1924C19.145 21.9734 20.4113 21.9734 21.1924 21.1924C21.9734 20.4113 21.9734 19.145 21.1924 18.364L19.071 16.2426C18.29 15.4616 17.0237 15.4616 16.2426 16.2426ZM16.9498 16.9498C16.5593 17.3403 16.5593 17.9734 16.9498 18.364L19.0711 20.4853C19.4616 20.8758 20.0948 20.8758 20.4853 20.4853C20.8758 20.0948 20.8758 19.4616 20.4853 19.0711L18.364 16.9498C17.9735 16.5592 17.3403 16.5592 16.9498 16.9498Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.659671c319e16b150585005963cb1942.svg";
export { ForwardRef as ReactComponent };